import script from "./GalleryDetailTopComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryDetailTopComponent.vue?vue&type=script&setup=true&lang=js"

import "./GalleryDetailTopComponent.vue?vue&type=style&index=0&id=393b49f0&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-393b49f0"]])

export default __exports__